import React from 'react';
export function HeroSection() {
  return <section aria-label="Ice Hockey Ready presentation" className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-116">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-117">
        <div className="flex flex-col items-center w-full pt-[0px] pb-[0px]" data-id="element-118">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-119">
            <span className="text-xl" aria-hidden="true" data-id="element-120">
              🏒
            </span>{' '}
            ICE HOCKEY READY
          </div>

          <h1 className="sm:text-4xl md:text-6xl lg:text-7xl tracking-tight px-2 text-[38px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[1.02] pt-[10px] pb-[10px]" data-id="element-121">
            Your entire
            <br data-id="element-122" />
            season of
            <br data-id="element-123" />
            <span className="text-brand-accent" data-id="element-124">ICE Hockey, solved.</span>
          </h1>
        </div>

        <div className="w-full max-w-[230px] sm:max-w-xs md:max-w-md mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" data-id="element-125">
          <picture data-id="element-126">
            <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/9P7xgHdrHZZbgM3gt74Qj7/image_(15).webp" data-id="element-127" />
            <img src="https://cdn.magicpatterns.com/uploads/9P7xgHdrHZZbgM3gt74Qj7/image_(15).webp" alt="Ice Hockey Ready — The Ultimate Coaching Vault, 6-in-1 box set" className="w-full h-auto object-contain relative z-10 mt-[-5px] mb-[-10px]" loading="eager" fetchPriority="high" decoding="sync" width={385} height={385} data-id="element-128" />
          </picture>
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-129">
          <p className="text-base sm:text-lg md:text-2xl text-white/85 leading-relaxed px-2 mb-6 md:mb-10 max-w-2xl" data-id="element-130">
            The 6-in-1 Professional Coaching Vault. Elite drills, tactical
            blueprints, and full seasonal systems. Organize your{' '}
            <span className="text-white font-bold" data-id="element-131">
              entire year in one afternoon
            </span>{' '}
            — and{' '}
            <span className="text-brand-accent font-bold" data-id="element-132">
              reclaim your Sundays for good.
            </span>
          </p>

          <div className="flex flex-nowrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10 w-full mx-auto px-1" data-id="element-133">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-134">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-135">
              ⚡ Instant Access
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90 whitespace-nowrap" data-id="element-136">
              🌍 Pro Standards (NHL/IIHF)
            </span>
          </div>

          <button onClick={() => {
          const TOP_OFFSET = 12;
          const DURATION = 1400;
          const startY = window.pageYOffset;
          const startTime = performance.now();
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const getTarget = () => {
            const sec = document.getElementById('pricing');
            if (!sec) return null;
            return sec.getBoundingClientRect().top + window.pageYOffset - TOP_OFFSET;
          };
          const step = (now: number) => {
            const elapsed = now - startTime;
            const t = Math.min(1, elapsed / DURATION);
            const eased = easeInOutCubic(t);
            const target = getTarget();
            if (target == null) {
              if (elapsed < DURATION + 2000) requestAnimationFrame(step);
              return;
            }
            const y = startY + (target - startY) * eased;
            window.scrollTo(0, y);
            if (t < 1) {
              requestAnimationFrame(step);
            } else if (Math.abs(window.pageYOffset - target) > 1) {
              const settleStart = performance.now();
              const settleFromY = window.pageYOffset;
              const settleDur = 350;
              const settleStep = (n2: number) => {
                const e2 = n2 - settleStart;
                const t2 = Math.min(1, e2 / settleDur);
                const tgt2 = getTarget();
                if (tgt2 == null) return;
                window.scrollTo(0, settleFromY + (tgt2 - settleFromY) * easeInOutCubic(t2));
                if (t2 < 1) requestAnimationFrame(settleStep);
              };
              requestAnimationFrame(settleStep);
            }
          };
          requestAnimationFrame(step);
        }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black text-xl md:text-3xl py-5 md:py-6 px-10 md:px-14 rounded-2xl transition-colors flex items-center justify-center mb-5 md:mb-8 mx-4 sm:mx-0 ml-[50px] mr-[50px] pl-[0px] pr-[0px]" data-id="element-137">
            🚀 → I WANT ICE HOCKEY READY NOW
          </button>

          <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-5 gap-y-2 text-xs md:text-sm text-white/80 font-semibold" data-id="element-138">
            <span className="flex items-center gap-1.5" data-id="element-139">
              <span className="text-brand-accent" data-id="element-140">🛡️</span> Satisfied or
              Refunded in 7 Days
            </span>
            <span className="text-white/20" aria-hidden="true" data-id="element-141">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-142">
              <span className="text-brand-accent" data-id="element-143">🔒</span> Secure Payment
            </span>
            <span className="text-white/20" aria-hidden="true" data-id="element-144">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-145">
              <span className="text-brand-accent" data-id="element-146">💳</span> One-time Payment
            </span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-147">
          <div className="text-center" data-id="element-148">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-149">
              +2,500
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-150">
              coaches trust us
            </div>
          </div>
          <div className="text-center" data-id="element-151">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-152">
              6
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-153">
              Ready Volumes
            </div>
          </div>
          <div className="text-center" data-id="element-154">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-155">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-156">
              Rating
            </div>
          </div>
          <div className="text-center" data-id="element-157">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-158">
              🌍
            </div>
            <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-159">
              Worldwide Community
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-160">
          {[{
          initials: 'MG',
          name: 'Marcus G.',
          loc: 'Minnesota | Head Performance Coach',
          quote: 'Finally, a resource that speaks the language of a modern pro coach. I organized my full U18 academy programming in a single afternoon.'
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Ontario | Professional Coach',
          quote: 'My sessions finally have a solid, professional structure. This gave me my free time back.'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Sweden | Certified Coach',
          quote: 'The Session Builder saved me. I never arrive at the rink unprepared again, even when the roster changes.'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-161">
              <div className="flex items-center gap-3 mb-3" data-id="element-162">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-163">
                  {test.initials}
                </div>
                <span className="text-brand-accent text-sm" aria-label="5 stars" data-id="element-164">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-165">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/70 uppercase tracking-wider font-bold" data-id="element-166">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}